import { render, staticRenderFns } from "./ContactSpeedInfo.vue?vue&type=template&id=ce648c40"
import script from "./ContactSpeedInfo.vue?vue&type=script&lang=js"
export * from "./ContactSpeedInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce648c40')) {
      api.createRecord('ce648c40', component.options)
    } else {
      api.reload('ce648c40', component.options)
    }
    module.hot.accept("./ContactSpeedInfo.vue?vue&type=template&id=ce648c40", function () {
      api.rerender('ce648c40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/home/components/ContactSpeedInfo.vue"
export default component.exports